import { render, staticRenderFns } from "./EleDialog.vue?vue&type=template&id=4d04f74a&scoped=true"
import script from "./EleDialog.vue?vue&type=script&lang=js"
export * from "./EleDialog.vue?vue&type=script&lang=js"
import style0 from "./EleDialog.vue?vue&type=style&index=0&id=4d04f74a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d04f74a",
  null
  
)

export default component.exports